import React from "react";
import { InfiniteScroll } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import BaseListPage from "../../../../../base/BaseListPage";
import Table from "../../../../../components/Table";
import ViewAccomplishmentPresenter from "./ViewAccomplishmentPresenter";
import Progress from "../../../../../components/Progress";

export default class ViewAccomplishment extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ViewAccomplishmentPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "accomplishment_profile";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.employeeID !== this.props.employeeID) {
  //     const accomplishsment = await findObjectUseCase().execute(
  //       "accomplishment_profile",
  //       { where: { "employee.id": this.props.employeeID } }
  //     );
  //     // console.warn("sdlfkjsdf: ", accomplishsment);
  //     this.setState({ newObj: accomplishsment, count: accomplishsment.length });
  //   }
  // }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  empID() {
    return this.props.employeeID;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, current, limit, loading } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div>
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <Table
              // objectId={this.handleDeleteData.bind(this)}
              // editId={this.handleEditData.bind(this)}
              progress={loading}
              refetch={this.refetchData.bind(this)}
              fields={schema.fields}
              objects={objects}
              collection={schema}
              count={count}
              limit={limit}
              current={current}
              loadPagination={this.onClickPagination.bind(this)}
              // actionsList={[
              //   {
              //     label: <i className="bi bi-three-dots-vertical" />,
              //     actionType: "common",
              //   },
              // ]}
              excludeFields={Object.keys(schema.fields).reduce(
                (acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                },
                [
                  "id",
                  "Created At",
                  "Updated At",
                  "acl",
                  "accomplishmentTitle",
                  "username",
                  "employee",
                ]
              )}
              onClickItem={this.onClickItem.bind(this)}
            />
          </InfiniteScroll>
        </div>
      </>
    );
  }
}
